function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { useState } from 'react';
import { FormBox } from "../FormBox";
import InputMask from 'react-input-mask';

import { FormInputEye, FormInputWrapper } from "./FormInput.styles";





















export const FormInput = ({
  label = 'Email address: ',
  error = '',
  input = {
    type: 'text',
    name: 'input',
    value: 'anytext@gmail.com',
    onChange: () => void 0,
    onClick: () => void 0,
    onFocus: () => void 0,
    onBlur: () => void 0 },

  eye }) =>
{
  const { type, name, value, onFocus, onBlur, mask } = input;

  const [active, setActive] = useState(false);
  const [activeEye, setActiveEye] = useState(false);
  const [inputType, setInputType] = useState(type);

  const changeInputType = React.useCallback(() => {
    setInputType(inputType === 'password' ? 'text' : 'password');
    setActiveEye(!activeEye);
  }, [activeEye, inputType]);

  return /*#__PURE__*/(
    React.createElement(FormBox, { inputName: name, active: active || !!value, label: label, error: error }, /*#__PURE__*/
    React.createElement(FormInputWrapper, null,
    eye ? /*#__PURE__*/
    React.createElement(FormInputEye, { active: active, onClick: changeInputType }) :
    null,
    mask ? /*#__PURE__*/
    React.createElement(InputMask, input) : /*#__PURE__*/

    React.createElement("input", _extends({

      autoComplete: "off" },
    input, {
      type: inputType,
      onFocus: (e) => {
        setActive(true);
        onFocus && onFocus(e);
      },
      onBlur: (e) => {
        setActive(false);
        onBlur && onBlur(e);
      } })))));





};